export default {
  title: 'Integrare Wolt Drive',
  subtitle: 'Vizibil doar pentru managerii de onboarding.',
  steps: {
    request: {
      title: '1. Solicită locația de la Wolt',
      description:
        'Copiază rândul acestui restaurant pentru foaia Wolt partajată. Lipește-l în coloana A din următorul rând gol, apoi anunță Wolt în canalul Slack comun.',
    },
    activate: {
      title: '2. Verifică și activează',
      description:
        'Introdu ID-ul locației adăugat de Wolt în foaie. Este verificat cu o cotație de test de la Wolt înainte de a salva ceva.',
    },
  },
  fields: {
    venue_id: {
      label: 'ID locație Wolt',
      placeholder: 'ex. 6736f9f5f9e2ab82f9150420',
      invalid: 'Un ID de locație Wolt are 24 de caractere și folosește doar 0–9 și a–f.',
    },
    priority: {
      label: 'Prioritate furnizor',
      options: {
        wolt_primary: 'Wolt principal, păstrează furnizorii actuali ca rezervă',
        wolt_only: 'Doar Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt a confirmat această locație.',
    failed: 'Wolt nu a putut confirma această locație.',
    wolt_reason: 'Wolt a spus: {{reason}}',
    unavailable_now: 'Wolt nu poate livra din acest local momentan ({{reason}}). Îl puteți salva în continuare.',
  },
  preview: {
    label: 'Ordinea furnizorilor',
    none: 'niciunul',
  },
  hints: {
    internal_delivery:
      'Acest restaurant livrează cu proprii șoferi. Wolt este folosit odată ce modul Livrare de mai jos este setat la șoferi externi.',
    invalid_stored_id:
      'ID-ul de local salvat {{venueId}} nu este un ID de local Wolt valid, deci Wolt nu este folosit pentru acest restaurant. Verificați și salvați-l pe cel corect.',
  },
  buttons: {
    copy_details: 'Copiază detaliile',
    verify: 'Verifică',
    save: 'Salvează',
  },
  confirm: {
    title: 'Activezi Wolt Drive?',
    description: 'Salvează ID-ul locației {{venueId}} și schimbă ordinea furnizorilor în: {{providers}}.',
    unsaved_providers: 'Modificările nesalvate din lista de furnizori de mai jos vor fi înlocuite.',
    ok: 'Salvează',
    cancel: 'Anulează',
  },
  toasts: {
    copied: 'Copiat',
    copy_failed: 'Detaliile nu au putut fi copiate. Încearcă din nou.',
    saved: 'Wolt Drive este configurat pentru acest restaurant.',
    save_failed: 'Nu s-a putut salva. Încearcă din nou.',
  },
};
